/* FOM · previa contextual de no (Fase 1AD.2 · hover-preview).

   Uma janela minima que responde "o que e isto?" sem abrir o painel:
   nome · gramatica (tipo real / selo de apresentacao) · estado epistemico ·
   contagens REAIS de conhecimento e lacunas · como entrar.

   Nada aqui inventa dado: tudo vem do proprio no carregado. Some ao sair,
   ao clicar e em toque (hover e um conceito de ponteiro fino). */
import type { FomNode } from '../core/types.ts';
import { ROTULO_ST, rotuloTipo} from '../core/types.ts';
import { seloDe } from '../dominio/apresentacao.ts';

export function montarPrevia(host: HTMLElement) {
  const el = document.createElement('div');
  el.className = 'previa-no';
  el.hidden = true;
  el.setAttribute('role', 'tooltip');
  host.appendChild(el);

  function mostrar(no: FomNode, x: number, y: number): void {
    el.textContent = '';
    const nome = document.createElement('p');
    nome.className = 'previa-nome';
    nome.textContent = no.name;
    el.appendChild(nome);

    const meta = document.createElement('p');
    meta.className = 'previa-meta';
    const selo = seloDe(no.external_id);
    const tipo = selo ?? rotuloTipo(no.node_type);
    meta.textContent = [tipo, ROTULO_ST[no.st]].filter(Boolean).join(' · ');
    el.appendChild(meta);

    if (no.know.length || no.gaps.length) {
      const contas = document.createElement('p');
      contas.className = 'previa-contas';
      const partes: string[] = [];
      if (no.know.length) partes.push(`conhecimento ${no.know.length}`);
      if (no.gaps.length) partes.push(`lacunas ${no.gaps.length}`);
      contas.textContent = partes.join(' · ');
      el.appendChild(contas);
    }

    const acao = document.createElement('p');
    acao.className = 'previa-acao';
    acao.textContent = 'clique para entrar';
    el.appendChild(acao);

    /* posiciona perto do ponteiro, sem sair da tela */
    const margem = 14;
    el.hidden = false;
    const w = el.offsetWidth || 220;
    const h = el.offsetHeight || 90;
    const vw = document.documentElement.clientWidth;
    const vh = document.documentElement.clientHeight;
    el.style.left = Math.min(x + margem, vw - w - 8) + 'px';
    el.style.top = Math.min(y + margem, vh - h - 8) + 'px';
  }

  function esconder(): void {
    el.hidden = true;
  }

  return { mostrar, esconder, get visivel(): boolean { return !el.hidden; } };
}
